import { ChatbotType } from '@newroom-connect/library/enums';

import { IBaseEntity } from './base-entity.interface';
import { IUserLicense } from './user-license.interface';
import { IArea } from './area.interface';

export interface IProjectTranslation {
  projectId: string;
  languageCode: string;
  createdAt: string;
  updatedAt: string;
  title: string;
}

export interface IProject extends IBaseEntity {
  ownerId: string;
  slug: string;
  startDate: string;
  endDate: string;
  timezone: string;
  userLicenseId: string;
  userLicense: IUserLicense;
  translations: IProjectTranslation[];
  startArea?: IArea;
  startAreaId?: string;
  analytics?: IProjectAnalytics;
  markets: IProjectMarket[];
  backgroundFileId?: string;
  navigation?: IProjectNavigation;
  advancedSettings?: IProjectAdvancedSettings;
  imprintFileId?: string;
  privacyPolicyFileId?: string;
  footerPages?: IFooterPage[];
  isPublic?: boolean;
  chatbotConfig?: IProjectChatbotConfig;
}

export interface IProjectLicenseQuotaUsage {
  storage: number;
  areas: number;
}

export interface IProjectAnalytics {
  id?: string;
  collectData: boolean;
  providers: IAnalyticsProvider[]
}

export interface IProjectMarket {
  id?: string;
  name: string;
  slugSuffix: string;
  languages: { code: string, name: string }[];
  country?: { code: string, name: string };
  countryCode?: string;
  markedForDelete?: boolean;
}

export interface IAnalyticsProvider {
  id?: string,
  analyticsKeyId: string;
  enabled: boolean;
  preset: IAnalyticsProviderPreset
}

export interface IAnalyticsProviderPreset {
  id: string;
  description: string;
  name: string;
  icon: string;
}

export interface IProjectSigninConfig {
  id: string;
  startAreaSlug: string;
  analytics: IProjectAnalytics;
  backgroundFileId?: string;
  imprintFileId?: string;
  privacyPolicyFileId?: string;
  footerPages?: IFooterPage[];
  customDomain?: string;
  isPublic?: boolean;
}

export interface IProjectNavigation {
  hideLogoutButton?: boolean;
  hideLanguageSelector?: boolean;
}

export interface IProjectChatbotConfig {
  chatbotType: ChatbotType;
  chatbotKey?: string;
  chatbotSecret?: string;
}

export interface IProjectAdvancedSettings {
  storageAdapter: StorageAdapter;
  authAdapter: AuthAdapter;
  emailAdapter: EmailAdapter;
  translateAdapter: TranslateAdapter;
  customDomain?: string | null;
  customEmailSender?: string | null;
}

export interface IFooterPage {
  title: string,
  slug: string,
  htmlFileId: string | null
}

export enum StorageAdapter {
  AMAZON_S3 = 'AMAZON_S3',
}

export enum AuthAdapter {
  AWS_COGNITO = 'AWS_COGNITO',
}

export enum EmailAdapter {
  AMAZON_SES = 'AMAZON_SES',
}

export enum TranslateAdapter {
  AWS_TRANSLATE = 'AWS_TRANSLATE',
}
